<template>
  <main>
    <div class="tab-content unit-condition">
      <div class="container-fluid">
        <div class="hint-text">※重要提醒：使用單位條件設定時，請確保使用之正確性與正當性，並遵循業務招攬相關規範及辦法。</div>
        <div id="tab-0" class="tab-pane active show" role="tabpanel">
          <form class="form">
            <div class="row mb-3">
              <div class="col-9">
                <h3 class="m-0 mt-1 mb-2">個人資料 
                  <div class="position-absolute d-inline-block form-select-count rounded-circle text-center ml-3">{{ count }}</div>
                </h3>
              </div>
            </div>

            <!-- 年紀相關block -->
            <div class="panel panel-default mb-2">
              <h4 class="text-green m-0">年紀相關</h4>
              <!-- 年齡 -->
              <div class="form-group row">
                <label class="col-2 text-right">年齡</label>
                <div class="col-10">
                  <div class="row">
                    <div v-for="(idage, index) in formSelect.idage" :key="index" :class="[idage.ser_no === 3 ? colsi : coltr]">
                      <div v-if="!(idage.ser_no === 3)" class="radio">
                        <input type="radio" v-model="formSelectItem.idage" :id="`age-${idage.ser_no}`" :value="idage.option">
                        <label :for="`age-${idage.ser_no}`">{{ idage.name }}</label>
                      </div>
                      <div v-else class="radio">
                        <input type="radio" v-model="formSelectItem.idage" :id="`age-${idage.ser_no}`" :value="`min:${form.extraAge[0]}/max:${form.extraAge[1]}`">
                        <label :for="`age-${idage.ser_no}`">
                          <input type="text" class="form-control form-control-inline form-short" v-model="form.extraAge[0]" maxlength="3" @input="checkExtraAge(0)" />
                          <span class="text">~</span>
                          <input type="text" class="form-control form-control-inline form-short" v-model="form.extraAge[1]" maxlength="3" @input="checkExtraAge(1)" />
                          <span class="text">歲(含)</span>
                        </label>
                      </div>
                    </div>
                  
                  </div>
                </div>
              </div>
              <!-- 生日月份 -->
              <div class="row">
                <div class="col-6">
                  <div class="form-group row">
                    <label for="birthMonth" class="col-4 text-right">生日月份</label>
                    <div class="col-5">
                      <select v-model="formSelectItem.birthmonth" id="birthMonth" class="form-control">
                        <option value="">請選擇</option>
                        <option v-for="(birthmonth, index) in formSelect.birthmonth" 
                        :key="index" 
                        :value="birthmonth.option">{{birthmonth.name}}</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 增齡月份 -->
              <div class="row">
                <div class="col-6">
                  <div class="form-group row">
                    <label for="add-age" class="col-4 text-right">增齡月份</label>
                    <div class="col-5">
                      <select v-model="formSelectItem.agemonth" id="add-age" class="form-control">
                        <option value="">請選擇</option>
                        <option v-for="(agemonth, index) in formSelect.agemonth" 
                        :key="index" 
                        :value="agemonth.option">{{agemonth.name}}</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 近期生日 -->
              <div class="row">
                <div class="col-6">
                  <div class="form-group row">
                    <label for="recent-birthday" class="col-4 text-right">近期生日</label>
                    <div class="col-5">
                      <select v-model="formSelectItem.recent_birthday" id="recent-birthday" class="form-control">
                        <option value="">請選擇</option>
                        <option v-for="(item, index) in formSelect.recent_birthday" 
                        :key="index" 
                        :value="item.option">{{item.name}}</option>
                      </select>
                    </div>
                    <label class="text-right">日內生日</label>
                  </div>
                </div>
              </div>
            </div>

            <!-- 基本資料block -->
            <div class="panel panel-default mb-2">
              <h4 class="text-green m-0">基本資料</h4>
              <!-- 性別 -->
              <div class="form-group row">
                <label for="gender-1" class="col-2 text-right">性別</label>
                <div class="col-10">
                  <div v-for="(sex, index) in formSelect.sex" :key="index" class="radio radio-inline mr-5">
                    <input type="radio" name="gender" v-model="formSelectItem.sex" :id="`gender-${sex.ser_no}`" :value="sex.option">
                    <label :for="`gender-${sex.ser_no}`">{{sex.name}}</label>
                  </div>
                </div>
              </div>
              <!-- 現居地址 -->
              <div class="form-group row">
                <label for="group" class="col-2 text-right">現居地址</label>
                <div class="col-10">
                  <select v-model="formSelectItem.home_addr.city" @change="changeCity" id="group-c" class="form-control form-control-inline form-wide">
                    <option value="">請選擇縣市</option>
                    <option
                    v-for="(city, cid) in cityOpt"
                    :key="`city-item-${cid}`"
                    :value="city">{{city}}</option>
                  </select>
                  <select v-model="formSelectItem.home_addr.zip" id="group-a" class="form-control form-control-inline form-wide" :disabled="formSelectItem.home_addr.city===''">
                    <option value="">請選擇鄉鎮市區</option>
                    <option
                    v-for="(area, aid) in areaOpt"
                    :key="`area-item-${aid}`"
                    :value="area.area">{{area.area}}</option>
                  </select>
                  <input type="text" class="form-control form-control-inline form-wide" 
                    :disabled="formSelectItem.home_addr.zip === ''"
                    v-model="formSelectItem.home_addr.street"
                    maxlength="100" @input="checkInputAddress"
                  />
                </div>
              </div>
              <!-- 所屬群組 -->
              <!-- <div class="form-group row">
                <label for="group" class="col-2 text-right">所屬群組</label>
                <div class="col-10">
                  <v-select 
                    :options="grpOpt.map(item => {return item.text})"
                    placeholder="請選擇或輸入群組名稱"
                    v-model="groupsVal"
                  >
                    <div slot="no-options">沒有資料可供選擇 !</div>
                  </v-select>
                  <select v-show="false" v-model="formSelectItem.groups" id="group" class="form-control">
                    <option value="">請選擇或輸入群組名稱</option>
                    <option
                    v-for="(grp, index) in grpOpt"
                    :key="`grp-item-${index}`"
                    :value="grp.text">{{grp.text}}</option>
                  </select>
                </div>
              </div> -->
              <!-- 婚姻狀況 -->
              <div class="form-group row">
                <label for="marriage" class="col-2 text-right">婚姻狀況</label>
                <div class="col-10" id="marriage">
                  <select v-model="formSelectItem.marry" class="form-control form-control-inline form-wide">
                    <option value="">請選擇</option>
                    <option v-for="(marry, index) in formSelect.marry" :key="index" :value="marry.option">{{marry.name}}</option>
                  </select>
                </div>
              </div>
              <!-- 教育程度 -->
              <div class="form-group row">
                <label for="education" class="col-2 text-right">教育程度</label>
                <div class="col-10" id="education">
                  <select v-model="formSelectItem.edu" class="form-control form-control-inline form-wide">
                    <option value="">請選擇</option>
                    <option v-for="(edu, index) in formSelect.edu" :key="index" :value="edu.option">{{edu.name}}</option>
                  </select>
                </div>
              </div>
              <!-- 職業 -->
              <div  class="form-group row">
                <label for="career" class="col-2 text-right">職業</label>
                <div class="col-10" id="career">
                  <b v-if="formSelectItem.std_occupation_cd" class="text px-3 text-green">第{{ formSelectItem.jobCategory }}類  {{ formSelectItem.job_name }}</b>
                  <a class="btn btn-default m-0"  @click="jobPickingOpen=true">請選擇</a>
                </div>
              </div>
            </div>

            <!-- 財務狀況block -->
            <div class="panel panel-default mb-2">
              <h4 class="text-green m-0">財務狀況</h4>
              <!-- 個人年所得 -->
              <div class="form-group row">
                <label class="col-2 text-right">個人年所得</label>
                <div class="col-10">
                  <select v-model="formSelectItem.incomy" class="form-control form-control-inline form-wide">
                    <option value="">請選擇</option>
                    <option v-for="(incomy, index) in formSelect.incomy" :key="index" :value="incomy.option">{{incomy.name}}</option>
                  </select>
                </div>
              </div>
              <!-- 家庭年所得 -->
              <div class="form-group row">
                <label class="col-2 text-right">家庭年所得</label>
                <div class="col-10">
                  <select v-model="formSelectItem.family_incom" class="form-control form-control-inline form-wide">
                    <option value="">請選擇</option>
                    <option v-for="(family_incom, index) in formSelect.family_incom" :key="index" :value="family_incom.option">{{family_incom.name}}</option>
                  </select>
                </div>
              </div>
              <!-- 月平均投資 -->
              <div class="form-group row">
                <label class="col-2 text-right">月平均投資</label>
                <div class="col-10">
                  <select v-model="formSelectItem.invest" class="form-control form-control-inline form-wide">
                    <option value="">請選擇</option>
                    <option v-for="(invest, index) in formSelect.invest" :key="index" :value="invest.option">{{invest.name}}</option>
                  </select>
                </div>
              </div>
              <!-- 理財工具 -->
              <div class="form-group row">
                <label class="col-2 text-right">理財工具</label>
                <div class="col-10">
                  <div v-for="(finance, index) in formSelect.finance" :key="index" class="checkbox checkbox-inline">
                    <input 
                    type="checkbox" :id="`financial_tools-${finance.ser_no}`" 
                    v-model="formSelectItem.finance" 
                    v-if="finance.name == '無理財工具'"
                    :value="finance.option">
                    <input v-else type="checkbox" :id="`financial_tools-${finance.ser_no}`" 
                    v-model="formSelectItem.finance" 
                    :disabled="formSelectItem.finance && formSelectItem.finance.includes('4')"
                    :value="finance.option">
                    <label :for="`financial_tools-${finance.ser_no}`">{{finance.name}}</label>
                  </div>
                </div>
              </div>
              <!-- 住屋狀況 -->
              <div class="form-group row">
                <label class="col-2 text-right">住屋狀況</label>
                <div class="col-10">
                  <select v-model="formSelectItem.house" class="form-control form-control-inline form-wide">
                    <option value="">請選擇</option>
                    <option v-for="(house, index) in formSelect.house" :key="index" :value="house.option">{{house.name}}</option>
                  </select>
                </div>
              </div>
              <!-- 交通工具 -->
              <div class="form-group row">
                <label class="col-2 text-right">交通工具</label>
                <div class="col-10">
                  <div v-for="(car, index) in formSelect.car" :key="index" class="radio radio-inline">
                    <input type="radio" :id="`transport-${car.ser_no}`" v-model="formSelectItem.car" :value="car.option">
                    <label :for="`transport-${car.ser_no}`">{{car.name}}</label>
                  </div>
                </div>
              </div>
            </div>

            <!-- 服務申辦項目block -->
            <div class="panel panel-default mb-2">
              <h4 class="text-green m-0">服務申辦項目</h4>
              <!-- 公司網站會員 -->
              <div class="form-group row mt-2">
                <label for="service_company-1" class="col-2 text-right">公司網站會員</label>
                <div class="col-10">
                  <div v-for="(web_member, index) in formSelect.web_member" :key="index" class="radio radio-inline">
                    <input type="radio" :id="`service_company-${web_member.ser_no}`" v-model="formSelectItem.web_member" :value="web_member.option">
                    <label :for="`service_company-${web_member.ser_no}`">{{web_member.name}}</label>
                  </div>
                </div>
              </div>
              <!-- 網路服務線上變更 -->
              <div class="form-group row mt-2">
                <label for="service_updateonline-1" class="col-2 text-right">網路服務線上變更</label>
                <div class="col-10">
                  <div v-for="(online, index) in formSelect.online" :key="index" class="radio radio-inline">
                    <input type="radio" :id="`service_updateonline-${online.ser_no}`" v-model="formSelectItem.online" :value="online.option">
                    <label :for="`service_updateonline-${online.ser_no}`">{{online.name}}</label>
                  </div>
                </div>
              </div>
              <!-- 行動服務 -->
              <div class="form-group row mt-2">
                <label for="service_mobile-1" class="col-2 text-right">行動服務</label>
                <div class="col-10">
                  <div v-for="(mobile, index) in formSelect.mobile" :key="index" class="radio radio-inline">
                    <input type="radio" :id="`service_mobile-${mobile.ser_no}`" v-model="formSelectItem.mobile" :value="mobile.option">
                    <label :for="`service_mobile-${mobile.ser_no}`">{{mobile.name}}</label>
                  </div>
                </div>
              </div>
              <!-- 一指通 -->
              <div class="form-group row mt-2">
                <label for="service_onefinger-1" class="col-2 text-right">一指通</label>
                <div class="col-10">
                  <div v-for="(payment, index) in formSelect.payment" :key="index" class="radio radio-inline">
                    <input type="radio" :id="`service_onefinger-${payment.ser_no}`" v-model="formSelectItem.payment" :value="payment.option">
                    <label :for="`service_onefinger-${payment.ser_no}`">{{payment.name}}</label>
                  </div>
                </div>
              </div>
              <!-- 電子單據 -->
              <div class="form-group row mt-2">
                <label for="service_ebill-1" class="col-2 text-right">電子單據</label>
                <div class="col-10">
                  <div v-for="(email, index) in formSelect.email" :key="index" class="radio radio-inline">
                    <input type="radio" :id="`service_ebill-${email.ser_no}`" v-model="formSelectItem.email" :value="email.option">
                    <label :for="`service_ebill-${email.ser_no}`">{{email.name}}</label>
                  </div>
                </div>
              </div>
              <!-- 轉帳申請 -->
              <div class="form-group row mt-2">
                <label for="service_transfer-1" class="col-2 text-right">轉帳申請</label>
                <div class="col-10">
                  <div v-for="(trans_plpy, index) in formSelect.trans_plpy" :key="index" class="radio radio-inline">
                    <input type="radio" :id="`service_transfer-${trans_plpy.ser_no}`" v-model="formSelectItem.trans_plpy" :value="trans_plpy.option">
                    <label :for="`service_transfer-${trans_plpy.ser_no}`">{{trans_plpy.name}}</label>
                  </div>
                </div>
              </div>
              <!-- 易call保 -->
              <div class="form-group row mt-2">
                <label for="service_eazycall-1" class="col-2 text-right">易Call保</label>
                <div class="col-10">
                  <div v-for="(ecall, index) in formSelect.ecall" :key="index" class="radio radio-inline">
                    <input type="radio" :id="`service_eazycall-${ecall.ser_no}`" v-model="formSelectItem.ecall" :value="ecall.option">
                    <label :for="`service_eazycall-${ecall.ser_no}`">{{ecall.name}}</label>
                  </div>
                </div>
              </div>
              <!-- 理賠抵繳 -->
              <div class="form-group row mt-2">
                <label for="service_settlement-1" class="col-2 text-right">理賠抵繳</label>
                <div class="col-10">
                  <div v-for="(claimoffset, index) in formSelect.claimoffset" :key="index" class="radio radio-inline">
                    <input type="radio" :id="`service_settlement-${claimoffset.ser_no}`" v-model="formSelectItem.claimoffset" :value="claimoffset.option">
                    <label :for="`service_settlement-${claimoffset.ser_no}`">{{claimoffset.name}}</label>
                  </div>
                </div>
              </div>
              <!-- 「FitBack健康吧」健康計劃 -->
              <div class="form-group row mt-2">
                <label for="service_cwp-1" class="col-2 text-right">「FitBack健康吧」<br />健康計劃</label>
                <div class="col-10">
                  <div v-for="(cwp, index) in formSelect.cwp" :key="index" class="radio radio-inline">
                    <input type="radio" :id="`service_cwp-${cwp.ser_no}`" v-model="formSelectItem.cwp" :value="cwp.option">
                    <label :for="`service_cwp-${cwp.ser_no}`">{{cwp.name}}</label>
                  </div>
                </div>
              </div>
            </div>
            <!-- 客戶類型block -->
            <div class="panel panel-default mb-2">
              <h4 class="text-green m-0">客戶類型</h4>
              <!-- 客戶關係 -->
              <div class="form-group row">
                <label for="customerType" class="col-2 text-right">客戶關係</label>
                <div class="col-10">
                  <div v-for="(custrl, index) in formSelect.custrl" :key="index" class="radio radio-inline">
                    <input type="radio" :id="`customerType-${custrl.ser_no}`" :value="custrl.option" v-model="formSelectItem.custrl" />
                    <label :for="`customerType-${custrl.ser_no}`">{{custrl.name}}</label>
                  </div>
                </div>
              </div>
              <!-- 保單關係人 -->
              <div class="form-group row mt-2">
                <label for="customerType-1" class="col-2 text-right">保單關係人</label>
                <div class="col-10">
                  <div v-for="(custrl1, index) in formSelect.custrl1" :key="index" class="radio radio-inline">
                    <input type="radio" :id="`customerType-1-${custrl1.ser_no}`" :value="custrl1.option" v-model="formSelectItem.custrl1" />
                    <label :for="`customerType-1-${custrl1.ser_no}`">{{custrl1.name}}</label>
                  </div>
                </div>
              </div>
              <!-- 幾年未再購 -->
              <div class="form-group row">
                <label for="" class="col-2 text-right">幾年未再購</label>
                <div class="col-2">
                  <select v-model="formSelectItem.custrl2" class="form-control">
                    <option value="">請選擇</option>
                    <option v-for="(year_select, index) in formSelect.year_select" :key="index" :value="year_select.option">{{year_select.name}}</option>
                  </select>
                </div>
              </div>
              <!-- 近期有購買 -->
              <div class="form-group row">
                <label for="" class="col-2 text-right">近期有購買</label>
                <div class="col-2">
                  <select v-model="formSelectItem.custrl3" class="form-control">
                    <option value="">請選擇</option>
                    <option v-for="(year_select, index) in formSelect.year_select" :key="index" :value="year_select.option">{{year_select.name}}</option>
                  </select>
                </div>
              </div>
              <!-- 投保始期 -->
              <div class="form-group row">
                <label for="group" class="col-2 text-right">投保始期</label>
                <div class="col-9">
                  <div class="row">
                    <div class="col-2">
                      <span class="text">民國</span>
                      <input type="text" class="form-control form-control-inline form-short" v-model="formSelectItem.inputYear" maxlength="3" @input="checkYear" />
                      <span class="text">年</span>
                    </div>
                    <div class="col-2">
                      <select v-model="formSelectItem.custrl4" class="form-control">
                        <option value="">請選擇</option>
                        <option v-for="(month_select, index) in formSelect.month_select" :key="index" :value="month_select.option">{{month_select.name}}</option>
                      </select>
                     </div>
                     <span class="text">月</span>
                    </div>
                  </div>
              </div>
              <!-- VIP客戶 -->
              <div class="form-group row mt-2">
                <label for="customerType-6" class="col-2 text-right">VIP客戶</label>
                <div class="col-10">
                  <div v-for="(vip_lvl, index) in formSelect.vip_lvl" :key="index" class="checkbox checkbox-inline">
                    <input type="checkbox" :id="`customerType-6-${vip_lvl.ser_no}`" v-model="formSelectItem.vip_lvl" :value="vip_lvl.option">
                    <label :for="`customerType-6-${vip_lvl.ser_no}`">{{vip_lvl.name}}</label>
                  </div>
                </div>
              </div>
              <!-- 客戶標籤 -->
              <div class="form-group row">
                <label for="fa-cust-tag" class="col-2 text-right">客戶標籤</label>
                <div class="col-8">
                  <div class="form-control h-auto"
                    @click="openCustTagModal(formSelectItem.cust_tag)">
                    <div v-if='formSelectItem.cust_tag.length == 0' style="padding:8px 0px;">
                    請選擇客戶標籤
                    </div>
                    <div v-else>
                      <div class="d-inline-block p-2 ml-2 mb-2" style="border-radius: 4px;background-color: #e0e1e3;" 
                        v-for="(item,key) in formSelectItem.cust_tag" :key="`selectedCustTag-${key}`">
                        {{ item.text }}
                      </div>
                    </div>
                  </div>
                </div>
                <label for="group" class="col-2 text-green underline" @click="openTagInfoModal">說明</label>
              </div>
              <!-- 符合名單專區次數 -->
              <div class="form-group row">
                <label class="col-2 text-right">符合名單專區次數</label>
                <div class="col-2">
                  <select v-model="formSelectItem.match_cnt" class="form-control">
                    <option value="">請選擇</option>
                    <option v-for="(cnt_select, index) in formSelect.cnt_select" :key="index" :value="cnt_select.option">{{cnt_select.name}}</option>
                  </select>
                </div>
              </div>
            </div>
            <!-- 商品行銷block -->
            <div class="row mb-3">
              <div class="col-9">
                <h3 class="m-0 mt-1 mb-2">商品行銷</h3>
              </div>
            </div>
            <!-- 已投保商品 -->
            <div class="panel panel-default mb-2">
              <h4 class="text-green mt-0">已投保商品</h4>
              <div class="form-group row mt-2">
                <label for="not_insure_mainDoc" class="col-2 text-right">主約幣別</label>
                <div class="col-10">
                  <div class="checkbox checkbox-inline">
                    <input type="checkbox" id = 'prod_codes-1'  value="NTD" v-model="formSelectItem.prod_codes_curr">
                    <label for="prod_codes-1">台幣</label>
                  </div>
                  <div class="checkbox checkbox-inline">
                    <input type="checkbox" id = 'prod_codes-2' value="USD" v-model="formSelectItem.prod_codes_curr">
                    <label for="prod_codes-2">美元</label>
                  </div>
                  <div class="checkbox checkbox-inline">
                    <input type="checkbox" id = 'prod_codes-3'  value="AUD" v-model="formSelectItem.prod_codes_curr">
                    <label for="prod_codes-3">澳幣</label>
                  </div>
                  <div class="checkbox checkbox-inline">
                    <input type="checkbox" id = 'prod_codes-4'  value="NZD" v-model="formSelectItem.prod_codes_curr">
                    <label for="prod_codes-4">紐幣</label>
                  </div>
                  <div class="checkbox checkbox-inline">
                    <input type="checkbox" id = 'prod_codes-5'  value="CNY" v-model="formSelectItem.prod_codes_curr">
                    <label for="prod_codes-5">人民幣</label>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="not_insure_mainDoc" class="col-2 text-right">主約險別</label>
                <div class="col-10">
                  <div class="form-control h-auto" 
                  @click="openSelectModal(formSelectItem.prod_codes.main,mainPlanOpt,'prod_codes','main')">
                    <div v-if='formSelectItem.prod_codes.main.length == 0' style="padding:8px 0px;">
                      請選擇或輸入商品名稱
                    </div>
                    <div v-else>
                      <div class="d-inline-block p-2 ml-2 mb-2" style="border-radius: 4px;background-color: #e0e1e3;" 
                      v-for="(item,key) in formSelectItem.prod_codes.main" :key="`selectedMainContract2-${key}`">
                        {{ item.text }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="not_insure_subDoc" class="col-2 text-right">附約險別</label>
                <div class="col-10">
                  <div class="form-control h-auto" 
                  @click="openSelectModal(formSelectItem.prod_codes.atta,secondaryPlanOpt,'prod_codes','atta')">
                    <div v-if='formSelectItem.prod_codes.atta.length == 0' style="padding:8px 0px;">
                      請選擇或輸入商品名稱
                    </div>
                    <div v-else>
                      <div class="d-inline-block p-2 ml-2 mb-2" style="border-radius: 4px;background-color: #e0e1e3;" 
                      v-for="(item,key) in formSelectItem.prod_codes.atta" :key="`selectedAttaContract2-${key}`">
                        {{ item.text }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="insure_prod_type" class="col-2 text-right">商品類別</label>
                <div class="col-10">
                  <div class="form-control h-auto" 
                  @click="openProdTypeModal(formSelectItem.prod_type, '1')">
                    <div v-if='formSelectItem.prod_type.length == 0' style="padding:8px 0px;">
                      請選擇商品類別
                    </div>
                    <div v-else>
                      <div class="d-inline-block p-2 ml-2 mb-2" style="border-radius: 4px;background-color: #e0e1e3;" 
                      v-for="(item,key) in formSelectItem.prod_type" :key="`selected-prod-type-${key}`">
                        {{ item.text }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 未投保商品 -->
            <div class="panel panel-default mb-2">
              <h4 class="text-green mt-0">未投保商品</h4>
              <div class="form-group row mt-2">
                <label for="not_insure_mainDoc" class="col-2 text-right">主約幣別</label>
                <div class="col-10">
                  <div class="checkbox checkbox-inline">
                    <input type="checkbox" id = "prod_codes_n-1" value="NTD" v-model="formSelectItem.prod_codes_n_curr">
                    <label for="prod_codes_n-1">台幣</label>
                  </div>
                  <div class="checkbox checkbox-inline">
                    <input type="checkbox" id = "prod_codes_n-2" value="USD" v-model="formSelectItem.prod_codes_n_curr">
                    <label for="prod_codes_n-2">美元</label>
                  </div>
                  <div class="checkbox checkbox-inline">
                    <input type="checkbox" id = "prod_codes_n-3" value="AUD" v-model="formSelectItem.prod_codes_n_curr">
                    <label for="prod_codes_n-3">澳幣</label>
                  </div>
                  <div class="checkbox checkbox-inline">
                    <input type="checkbox" id = "prod_codes_n-4" value="NZD" v-model="formSelectItem.prod_codes_n_curr">
                    <label for="prod_codes_n-4">紐幣</label>
                  </div>
                  <div class="checkbox checkbox-inline">
                    <input type="checkbox" id = "prod_codes_n-5" value="CNY" v-model="formSelectItem.prod_codes_n_curr">
                    <label for="prod_codes_n-5">人民幣</label>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="not_insure_mainDoc" class="col-2 text-right">主約險別</label>
                <div class="col-10">
                  <div class="form-control h-auto" 
                  @click="openSelectModal(formSelectItem.prod_codes_n.main,mainPlanOpt,'prod_codes_n','main')">
                    <div v-if='formSelectItem.prod_codes_n.main.length == 0' style="padding:8px 0px;">
                      請選擇或輸入商品名稱
                    </div>
                    <div v-else>
                      <div class="d-inline-block p-2 ml-2 mb-2" style="border-radius: 4px;background-color: #e0e1e3;" 
                      v-for="(value,key) in formSelectItem.prod_codes_n.main" :key="`selectedMainContract2-${key}`">{{ value.text }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="not_insure_subDoc" class="col-2 text-right">附約險別</label>
                <div class="col-10">
                  <div class="form-control h-auto" 
                  @click="openSelectModal(formSelectItem.prod_codes_n.atta,secondaryPlanOpt,'prod_codes_n','atta')">
                    <div v-if='formSelectItem.prod_codes_n.atta.length == 0' style="padding:8px 0px;">
                      請選擇或輸入商品名稱
                    </div>
                    <div v-else>
                      <div class="d-inline-block p-2 ml-2 mb-2" style="border-radius: 4px;background-color: #e0e1e3;" 
                      v-for="(value,key) in formSelectItem.prod_codes_n.atta" :key="`selectedAttaContract2-${key}`">{{ value.text }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group row mt-2">
                <label for="not_insure_prod_type" class="col-2 text-right">商品類別</label>
                <div class="col-10">
                  <div class="form-control h-auto" 
                  @click="openProdTypeModal(formSelectItem.prod_type_n, '2')">
                    <div v-if='formSelectItem.prod_type_n.length == 0' style="padding:8px 0px;">
                      請選擇商品類別
                    </div>
                    <div v-else>
                      <div class="d-inline-block p-2 ml-2 mb-2" style="border-radius: 4px;background-color: #e0e1e3;" 
                      v-for="(value,key) in formSelectItem.prod_type_n" :key="`selected-prod-type-n-${key}`">{{ value.text }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 泰好客 -->
            <div class="panel panel-default mb-2">
              <h4 class="text-green mt-0">泰好客</h4>
              <div class="form-group row mt-2">
                <label class="col-2 text-right">促約潛力</label>
                <div class="col-10">
                  <div class="checkbox checkbox-inline">
                    <input type="checkbox" id = "mkt_level_1" value="高" v-model="formSelectItem.mkt_level">
                    <label for="mkt_level_1">高促約潛力</label>
                  </div>
                  <div class="checkbox checkbox-inline">
                    <input type="checkbox" id = "mkt_level_2" value="中高" v-model="formSelectItem.mkt_level">
                    <label for="mkt_level_2">中高促約潛力</label>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-2 text-right">商品類別</label>
                <div class="col-10">
                  <div class="form-control h-auto" 
                  @click="openAddMktTypeModal(formSelectItem.mkt_type)">
                    <div v-if='formSelectItem.mkt_type && formSelectItem.mkt_type.length == 0' style="padding:8px 0px;">
                      請選擇商品類別
                    </div>
                    <div v-else>
                      <div class="d-inline-block p-2 ml-2 mb-2" style="border-radius: 4px;background-color: #e0e1e3;" 
                      v-for="(item,key) in formSelectItem.mkt_type" :key="`selected-mkt_type-${key}`">
                        {{ item.text }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-9">
                <h3 class="m-0 mt-1 mb-2">契約事件</h3>
              </div>
            </div>
            <!-- 未來一個月給付 -->
            <div class="panel panel-default mb-2">
              <h4 class="text-green mt-0">給付</h4>
              <!-- 滿期金即將給付 -->
              <div class="form-group row">
                <label for="" class="col-2 text-right">滿期金即將給付</label>
                <div class="col-10">
                  <select v-model="formSelectItem.matag_month" class="form-control">
                    <option value="">請選擇</option>
                    <option v-for="(matag_month, index) in formSelect.matag_month" :key="index" :value="matag_month.option">{{matag_month.name}}</option>
                  </select>
                </div>
              </div>
              <!-- 年金即將給付 -->
              <div class="form-group row">
                <label for="" class="col-2 text-right">年金即將給付</label>
                <div class="col-10">
                  <select v-model="formSelectItem.annuity_month" class="form-control">
                    <option value="">請選擇</option>
                    <option v-for="(annuity_month, index) in formSelect.annuity_month" :key="index" :value="annuity_month.option">{{annuity_month.name}}</option>
                  </select>
                </div>
              </div>
            </div>
            <!-- 續保 -->
            <div class="panel panel-default mb-2">
              <h4 class="text-green mt-0">續保</h4>
              <!-- 意外險 -->
              <div class="form-group row">
                <label for="" class="col-2 text-right">意外險</label>
                <div class="col-10">
                  <select v-model="formSelectItem.pla1_month" class="form-control">
                    <option value="">請選擇</option>
                    <option v-for="(pla1_month, index) in formSelect.pla1_month" :key="index" :value="pla1_month.option">{{pla1_month.name}}</option>
                  </select>
                </div>
              </div>
              <!-- 車險 -->
              <div class="form-group row">
                <label for="" class="col-2 text-right">車險</label>
                <div class="col-10">
                  <select v-model="formSelectItem.plc1_month" class="form-control">
                    <option value="">請選擇</option>
                    <option v-for="(plc1_month, index) in formSelect.plc1_month" :key="index" :value="plc1_month.option">{{plc1_month.name}}</option>
                  </select>
                </div>
              </div>
              <!-- 火險 -->
              <div class="form-group row">
                <label for="" class="col-2 text-right">火險</label>
                <div class="col-10">
                  <select v-model="formSelectItem.plf1_month" class="form-control">
                    <option value="">請選擇</option>
                    <option v-for="(plf1_month, index) in formSelect.plf1_month" :key="index" :value="plf1_month.option">{{plf1_month.name}}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="text-right">
              <div class="checkbox checkbox-inline">
                <label for="favrite">
                  將篩選條件取個名字：
                </label>
              </div>
              <div style="display: inline-block;">
                <input type="text"
                  placeholder="請輸入標題"
                  class="form-control"
                  style="width: 250px;"
                  v-model="condition_title"
                  maxlength="40"
                  @input="checkTitle"
                />
                <input type="text"
                placeholder="請輸入標題"
                class="form-control"
                style="width: 250px; display: none;"
                v-model="updateVal"/>
              </div>
            </div>
            <div class="action text-right">
              <button type="button" class="btn btn-default"
              @click="resetformData">
                重設
              </button>

              <button type="button" class="btn btn-default" :disabled="submitDisable"
              @click.prevent="previewClient">
                客戶數預覽
              </button>

              <button type="button" class="btn btn-primary" :disabled="submitDisable"
              @click.prevent="formSubmit()"
              >
                下一步
              </button>
            </div>
           
          </form>
        </div>
      </div>
    </div>

    <job-picking-modal :open="jobPickingOpen" @submit="submitJob" @close="jobPickingOpen=false" />

    <!-- 商品主附選擇 modal -->
    <add-contract-modal
    type="manageruse"
    :open="selectModalOpen"
    :selectedContract="modalSelected"
    :allContract="modalUnselected"
    :title="selectModalTitle"
    @close="panelClose('selectModalOpen')"
    @submit="updateContract"
    />

    <!-- 客戶標籤說明視窗 -->
    <tag-info-modal
      :open="tagInfoModalOpen"
      :data="custTagOpt"
      :def="custTagDef"
      @close="panelClose('tagInfoModalOpen')"
    />

    <!-- 客戶標籤選擇 modal -->
    <add-cust-tag-modal
      type="manageruse"
      :open="custTagModalOpen"
      :selectedTag="custTagSelected"
      :allTag="allTagOpt"
      @close="panelClose('custTagModalOpen')"
      @submit="updateCustTag"
    />

    <!-- 商品類別選擇 modal -->
    <add-prod-type-modal
      type="manageruse"
      :open="prodTypeModalOpen"
      :selectedProd="prodTypeSelected"
      :prodType1="prodType1_Opt"
      :prodType2="prodType2_Opt"
      @close="panelClose('prodTypeModalOpen')"
      @submit="updateProdType"
    />

    <!-- 挑選商品類別(泰好客) -->
    <add-mkt-type-modal
      type="manageruse"
      :open="addMktTypeModalOpen"
      :selectedMktType="mktTypeSelected"
      @close="panelClose('addMktTypeModalOpen')"
      @submit="updateMktType"
    />

    <!-- 泰好客說明視窗 -->
    <cathay-cust-info-modal
      :open="cathayCustInfoModalOpen"
      @close="panelClose('cathayCustInfoModalOpen')"
    />
  </main>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {commonMixin} from '@/mixins/common'
import { queryDistByCity } from '@/service'
import AddContractModal from '@/desktop/components/AddContractModal'
import AddCustTagModal from '@/desktop/components/AddCustTagModal'
import TagInfoModal from '@/desktop/components/TagInfoModal'
import AddProdTypeModal from '@/desktop/components/AddProdTypeModal'
import AddMktTypeModal from '@/desktop/components/AddMktTypeModal'
import CathayCustInfoModal from '@/desktop/components/CathayCustInfoModal'
import JobPickingModal from '@/desktop/components/JobPickingModal';

export default {
  name: 'UnitCondition',
  mixins: [commonMixin],
  components: {AddContractModal, AddCustTagModal, TagInfoModal, AddProdTypeModal, AddMktTypeModal, CathayCustInfoModal, JobPickingModal},
  computed: {
    ...mapGetters([
      'Cities', 'SliceMode'
    ]),
  },
  props: {
    formSelect: {
      type: Object,
      default: () => {
        return {}
      }
    },
    grpOpt: {  
      type: Array,
      default: () => {
        return []
      }
    },
    mainPlanOpt: {
      type: Array,
      default: () => {
        return []
      }
    },
    secondaryPlanOpt: {
      type: Array,
      default: () => {
        return []
      }
    },
    status: {
      type: String,
      default: ''
    },
    custTagOpt: {
      type: Array,
      default: () => {
        return []
      }
    },
    prodType1_Opt: {
      type: Array,
      default: () => {
        return []
      }
    },
    prodType2_Opt: {
      type: Array,
      default: () => {
        return []
      }
    },
    custTagDef: {
      type: Object,
      default: () => {
        return {};
      }
    },
    allTagOpt: {
      type: Array
    }
  },
  data () {  //data block layout
    return {
      jobPickingOpen: false,
      updateVal: '',
      condition_title: '',
      selectModalTitle: '',
      count: 0,
      selectModalOpen: false,
      groupsVal:'',
      cityOpt: [],
      areaOpt: [],
      modalUnselected: [],
      modalSelected: [],
      modalType: '',
      modalLevel: '',
      coltr:'col-3',
      colsi:'col-6',
      conditionData: {},
      option_ch: '',  // 選項中文
      form: {
        extraAge: ['','']
      },
      formSelectItem: {
        idage:'',
        agemonth:'',
        custrl:'',
        custrl1:'',
        custrl2:'',
        custrl3:'',
        custrl4:'',
        vip_lvl:[],
        std_occupation_cd:'',
        job_name: '',
        jobCategory: '',
        family_incom:'',
        finance:[], //Array
        invest:'',
        marry:'',
        edu:'',
        house:'',
        car:'',
        web_member:'',
        online:'',
        mobile:'',
        payment:'',
        email:'',
        sex:'',
        trans_plpy:'',
        ecall:'',
        claimoffset:'',
        matag_month:'',
        annuity_month:'',
        pla1_month:'',
        plc1_month:'',
        plf1_month:'',
        birthmonth:'',
        incomy:'',
        home_addr:{
          city:'',
          zip:'',
          street:'',
        },
        groups:'',
        prod_codes:{
          main: [],
          atta: [],
        },
        prod_codes_n:{
          main: [],
          atta: [],
        },
        prod_codes_curr:[],
        prod_codes_n_curr:[],
        inputYear:'',
        cust_tag: [],//客戶標籤
        match_cnt:'', //符合名單專區次數
        cwp:'', //「FitBack健康吧」健康計畫
        prod_type:[], //已投保_商品類別
        prod_type_n:[], //未投保_商品類別
        recent_birthday: '', //近期生日
        mkt_level: [], //泰好客(促約潛力)
        mkt_type: []  //泰好客(商品類別)
      },
      submitDisable: true,
      ageCheck: true,
      yearCheck: true,
      custTagSelected: [], //已選擇的客戶標籤
      custTagModalOpen: false,
      tagInfoModalOpen: false,
      prodTypeSelected: [], //已選擇的商品類別
      prodTypeModalOpen: false,
      prodType:'', //當前選取的商品類別(1:已投保 / 2:未投保)
      mktTypeSelected: [], //已選擇的商品類別(泰好客)
      addMktTypeModalOpen: false,
      cathayCustInfoModalOpen: false //泰好客說明視窗
    }
  },
  watch:{
    formSelectItem: {  // 判斷使用者是否有選擇條件
      handler(newVal) {
        this.count = 0
        let hasVal = false
        for(let item in newVal){
          let val = newVal[item]
          if(typeof val == 'object' && !Array.isArray(val)) {
            if(item == 'home_addr' && val.city !== '') {
              hasVal = true
              this.count++;
            }else if(item == 'prod_codes' || item == 'prod_codes_n') {
              for(let j in val) {
                if(val[j].length !== 0) {
                  hasVal = true
                  this.count++;
                }
              }
            }
          }else if(Array.isArray(val)) {
            if(val.length > 0) {
              hasVal = true
              this.count++;
            }
          }else if(val !== ''){
            hasVal = true
            this.count++;
          }
        }
        if(hasVal && this.formSelectItem.idage){  // 特別判斷自定義年齡
          if( this.form.extraAge[0] === '' && this.form.extraAge[1] === ''){
            this.submitDisable = false
          }else if(this.form.extraAge[0] !== '' && this.form.extraAge[1] !== ''){
            this.submitDisable = false
          }else{
            this.submitDisable = false
          }
        }else if(hasVal){
          this.submitDisable = false
        }else{
          this.submitDisable = true
        }
      },
      deep: true,
      immediate: true
    },
    count (val) {
      if(val > 15) {
        this.setToastMsg('條件組合不得設定超過15項條件')
      }
    },
    groupsVal(){ // 雙向綁定 v-select 元件 群組 model
      if(this.groupsVal !== null){
        this.formSelectItem.groups = this.groupsVal.trim()
      }else{
        this.formSelectItem.groups = ''
      }
    },
    'form.extraAge': function(){
      if(this.form.extraAge[0] == '' && this.form.extraAge[1] == ''){
        this.formSelectItem.idage = ''
      }else{
        this.formSelectItem.idage = `min:${this.form.extraAge[0]}/max:${this.form.extraAge[1]}`
      }
    },
    'formSelectItem.groups': function(newVal,oldVal){
      this.groupsVal = this.formSelectItem.groups
    },
    status (val) {  // 監聽 component 切換
      if (val == 'STATUS_UNIT_CONDITION') {
        this.updateVal += '0'
      }
    },
    'formSelectItem.mkt_level' : function (val) {
      if (!val.length && this.formSelectItem.mkt_type.length) {
        this.formSelectItem.mkt_type = []; //取消勾選所有促約潛力，則把商品類別清空
      }
    },
    'formSelectItem.mkt_type' : function (val) {
      if (val && val.length) {
        if (this.formSelectItem.mkt_level && !this.formSelectItem.mkt_level.length) {
          this.formSelectItem.mkt_level.push("高");
          this.formSelectItem.mkt_level.push("中高");
        }
      } else {
        this.formSelectItem.mkt_level = []; //取消勾選商品類別，則把促約潛力清空
      }
    }
  },
  methods: {
    //選擇職業
    submitJob(job) {
      this.formSelectItem.job_name = job.job_name;
      this.formSelectItem.jobCategory = job.job_cat;
      this.formSelectItem.std_occupation_cd = job.job_code;
      this.jobPickingOpen = false;
    },
    //檢查輸入年紀
    checkExtraAge(index){
      this.form.extraAge[index] = this.form.extraAge[index].replace(/[^\d]/g,'');
    },
    //檢查輸入地址
    checkInputAddress(){
      this.formSelectItem.home_addr.street = this.formSelectItem.home_addr.street.replace(/[<>!@#$^&,."'?%*:;+_/{}[\]|~`=\\\s]/g,'');
      if (this.stringBytes(this.formSelectItem.home_addr.street, false, 100) > 100) {
        this.formSelectItem.home_addr.street = this.formSelectItem.home_addr.street.substring(0, this.stringBytes(this.formSelectItem.home_addr.street, true, 100));
      }
    },
    //檢查投保始期-年份
    checkYear(){
      this.formSelectItem.inputYear = this.formSelectItem.inputYear.replace(/[^\d]/g,'');
    },
    //檢查輸入篩選條件的標題
    checkTitle(){
      if (this.stringBytes(this.condition_title, false, 40) > 40) {
        this.condition_title = this.condition_title.substring(0, this.stringBytes(this.condition_title, true, 40));
      }
    },
    ...mapActions([
      'setPageLock'
    ]),
    initUnitFilter () {  // 初始化
      this.setCityOpt() // 取得縣市
    },
    setCityOpt () {  // 取得縣市
      this.cityOpt = this.Cities.map(item => item.city)
    },
    curr(item){
      switch(item){
        case 'NTD':
          return "台幣"
          break
        case 'USD':
          return "美元"
          break
        case 'AUD':
          return "澳幣"
          break
        case 'NZD':
          return "紐幣"
          break
        case 'CNY':
          return "人民幣"
          break
      }
    },
    changeCity () {
      this.formSelectItem.home_addr.zip = ''
      this.formSelectItem.home_addr.street = ''
      if(this.formSelectItem.home_addr.city == ''){
        this.areaOpt = []
      }else{
        queryDistByCity(this.$store.state.userInfo.id, this.formSelectItem.home_addr.city).then(result => {
          if(result.body.cityAreaList) {  
            this.areaOpt = result.body.cityAreaList.map(item => { return {area: item.AREA, city:item.CITY, zipcode:item.ZIPCODE}})
          } else {
            this.areaOpt = []
          }
        })
      }
    },
    openSelectModal(selected,unselected, type, level) {  //  打開投保商品選擇 modal
      this.modalSelected = selected;
      this.modalUnselected = unselected;
      this.modalType = type
      this.modalLevel = level
      if (type == 'prod_codes') {
        if(level == 'main') {
          this.selectModalTitle = '已投保主約'
        }else if(level == 'atta') {
          this.selectModalTitle = '已投保附約'
        }
      }else if (type == 'prod_codes_n') {
        if(level == 'main') {
          this.selectModalTitle = '未投保主約'
        } else if (level == 'atta'){
          this.selectModalTitle = '未投保附約'
        }
      }
      this.panelOpen('selectModalOpen')
    },
    stringBytes(c, isSub, size){ //計算字元長度 (字串, 是否檢查, 檢查的長度) 
      var n=c.length,s;
      var len=0;
      for(var i=0; i <n;i++){
        s=c.charCodeAt(i);
        while( s > 0 ){
          len++;
          s = s >> 8;
          if(isSub&&len>size){
            return i;
          }
        }
      }
      return len;
    },
    resetformData(){
      this.form.extraAge = ['', '']
      this.formSelectItem = {
        idage:'',
        agemonth:'',
        custrl:'',
        custrl1:'',
        custrl2:'',
        custrl3:'',
        custrl4:'',
        vip_lvl:[],
        std_occupation_cd:'',
        job_name: '',
        jobCategory: '',
        family_incom:'',
        finance:[], //Array
        invest:'',
        marry:'',
        edu:'',
        house:'',
        car:'',
        web_member:'',
        online:'',
        mobile:'',
        payment:'',
        email:'',
        sex:'',
        trans_plpy:'',
        ecall:'',
        claimoffset:'',
        matag_month:'',
        annuity_month:'',
        pla1_month:'',
        plc1_month:'',
        plf1_month:'',
        birthmonth:'',
        incomy:'',
        home_addr:{
          city:'',
          zip:'',
          street:'',
        },
        groups:'',
        prod_codes:{
          main:[],
          atta:[],
        },
        prod_codes_n:{
          main:[],
          atta:[],
        },
        prod_codes_curr:[],
        prod_codes_n_curr:[],
        inputYear:'', //投保始期民國年
        cust_tag:[],
        match_cnt:'', //符合名單專區次數
        cwp:'',
        prod_type:[],
        prod_type_n:[],
        recent_birthday:''
      }
    },
    updateContract (selectedList) {  //  更新已選擇投保商品
      this.formSelectItem[this.modalType][this.modalLevel] = selectedList
      this.panelClose('selectModalOpen')
    },
    setCondition () {  // 設定 condition
      this.ageCheck = true;
      this.yearCheck = true;
      const form = this.formSelectItem
      const formItem = this.formSelect
      const extraAge = this.form.extraAge
      const grpOpt = this.grpOpt
      const areaOpt = this.areaOpt
      const mainPlanOpt = this.mainPlanOpt
      const secondaryPlanOpt = this.secondaryPlanOpt
      let filterAry = []
      let idageCustomize = ''     //特別對應自定義年齡
      formItem.idage.forEach(ageItem => {
        if(ageItem.option === form.idage){
          idageCustomize = idageCustomize + '1'
        }else{
          idageCustomize = idageCustomize + '0'
        }
      })
      
      for(let key in form){  //如果是字串或是數字
        if(form[key] !== '' && typeof form[key] !== 'object'){
          if(formItem[key]){
            formItem[key].forEach(item => {
              if(item.option == form[key]){
                filterAry.push({title:`${item.field_description}:${item.name}`,field_name:item.field_name,option:item.option})
              }
            })
          }

          //職業
          if(key === 'std_occupation_cd'){
            filterAry.push({title:`職業:第${form.jobCategory}類 ${form.job_name}`,field_name:'std_occupation_cd',option:form.std_occupation_cd});
          }

          //投保始期民國年
          if(key === 'inputYear'){
            //檢查輸入年度是否為數字
            if (this.checkCustomizedAge('year', form.inputYear)) {
              return;
            }
          }

          //幾年未再購
          if(key === 'custrl2'){
            filterAry.push({title:`幾年未再購:${form.custrl2}`,field_name:'custrl2',option:form.custrl2});
          }

          //近期有購買
          if(key === 'custrl3'){
            filterAry.push({title:`近期有購買:${form.custrl3}`,field_name:'custrl3',option:form.custrl3});
          }

          //符合名單專區次數
          if (key === 'match_cnt' && formItem['cnt_select']) {
            formItem['cnt_select'].forEach(item => {
              if(item.option == form[key]){
                filterAry.push({title:`符合名單專區次數:${item.name}`,field_name:'match_cnt',option:item.option});
              }
            });
          }

          if(key === 'groups'){  //如果項目是 groups API
            grpOpt.forEach(item => {
              if(item.text.trim() == form[key].trim()){

                filterAry.push({title:`所屬群組:${item.text.trim()}`,field_name:'groups',option:item.val})
              }
            })
          }

          if (key === 'idage' && (idageCustomize.indexOf('1') === -1)) { //特別對應自定義年齡
            let extraAgeMin = this.form.extraAge[0].trim();
            let extraAgeMax = this.form.extraAge[1].trim();
            if (extraAgeMin !== '' || extraAgeMax !== '') {
              //檢查輸入年齡是否為數字
              if (this.checkCustomizedAge('age', extraAgeMin) || this.checkCustomizedAge('age', extraAgeMax)) {
                return;
              }
            }
            if (extraAgeMin !== '' && extraAgeMax === '') {
              filterAry.push({title:`年齡大於等於:` + extraAgeMin + `歲`, field_name:'idageCustomize', option:`min:` + extraAgeMin});
            } else if (extraAgeMin === '' && extraAgeMax !== '') {
              filterAry.push({title:`年齡小於等於:` + extraAgeMax + `歲`, field_name:'idageCustomize', option:`max:` + extraAgeMax});
            } else if(extraAgeMin !== '' && extraAgeMax !== '') {
              filterAry.push({title:`年齡:` + extraAgeMin + `歲~` + extraAgeMax + `歲`, field_name:'idage', option:`min:` + extraAgeMin + `/max:` + extraAgeMax});
            }
          }
        }
        else if(typeof form[key] === 'object'){  
          
          // 如果項目是 Array 
          if( key === 'finance'  && form[key].length > 0 ){    
            let pushString = []
            let pushOption = []
            let descriptionTitle = ''
            let desField_name = ''
            let newAry = [0,0,0,0,0,0,0,0,0]
            formItem[key].forEach(itemX => {
              form[key].forEach(itemY => {
                if(itemX.option == itemY){
                  pushString.push(itemX.name)
                  pushOption.push(itemX.option)
                  descriptionTitle = itemX.field_description
                  desField_name = itemX.field_name
                }
              })
            })
            pushString = pushString.join()
            if(!form[key].includes('4')){
              pushOption = newAry.map((item,index) => {
              if(pushOption.includes((index + 1).toString())){
                  return index + 1
                }else{
                  return 0
                }
              }).join('')
            }
            else{
              pushOption = newAry.join('')
              pushString = '無理財工具'
            }
            
            filterAry.push({title:`${descriptionTitle}:${pushString}`,field_name:desField_name,option:pushOption})

          // 如果項目是 現居地址 Object 
          }else if(key === 'home_addr' && form[key].city !== ''){
            let setArea = ''
            let setOption = ''
            areaOpt.forEach(item => {
              if(form[key].zip === item.area){
                setArea = item.area
                setOption = item.zipcode
              }
            })
            filterAry.push({title:`縣市:${form[key].city}`,field_name:'home_addr1',option:form[key].city})
            if(form[key].zip){
              filterAry.push({title:`鄉鎮市區:${setArea}`,field_name:'home_addr2',option:setArea})
            }
            if(form[key].street){
              filterAry.push({title:`地址:${form[key].street}`,field_name:'home_addr3',option:form[key].street})
            }
            
          
          // 如果項目是 已投保商品 Object
          }else if(key === 'prod_codes' && (form[key].atta.length !== 0 || form[key].main.length !== 0)){
            let setMain = ''
            let setAtta = ''
            let setMOption = ''
            let setAOption = ''
            if(form[key].main.length !== 0){
              setMain = '主約:' + form[key].main.map(item => item.val).join(':')
              setMOption = form[key].main.map(item => item.val.trim()).join(':')
            }
            if(form[key].atta.length !== 0){
              setAtta = '附約:' + form[key].atta.map(item => item.val).join(':')
              setAOption = form[key].atta.map(item => item.val.trim()).join(':')
            }
            
            let filterOption = ''
            if(setMOption && setAOption){
              filterOption = setMOption + ':' + setAOption
            }else if(setMOption && !setAOption){
              //只有主約
              filterOption = setMOption + '!'
            }else{
              //只有附約
              filterOption = setAOption 
            }
            filterAry.push({title:`已投商品:${setMain}${setAtta}`,field_name:'prod_codes',option:filterOption})


          // 如果項目是 未投保商品 Object
          }
          else if(key === 'prod_codes_n' && (form[key].atta.length !== 0 || form[key].main.length !== 0)){
            let setMain = ''
            let setAtta = ''
            let setMOption = ''
            let setAOption = ''
            if(form[key].main.length !== 0){
              setMain = '主約:' + form[key].main.map(item => item.val).join(':')
              setMOption = form[key].main.map(item => item.val.trim()).join(':')
            }
            if(form[key].atta.length !== 0){
              setAtta = '附約:' + form[key].atta.map(item => item.val).join(':')
              setAOption = form[key].atta.map(item => item.val.trim()).join(':')
            }
            let filterOption = ''
            if(setMOption && setAOption){
              filterOption = setMOption + ':' + setAOption
            }else if(setMOption && !setAOption){
              //只有主約
              filterOption = setMOption + '!'
            }else {
              //只有附約
              filterOption = setAOption 
            }
            filterAry.push({title:`未投商品:${setMain}${setAtta}`,field_name:'prod_codes_n',option:filterOption})
          }
           //已投保商品幣別
          else if(key === 'prod_codes_curr' && form[key].length !== 0){
            let setCurr = ''
            let setCOption = ''            
            setCurr = '幣別:' + form[key].map(this.curr).join(':')
            setCOption = form[key].map(item => item.trim()).join(':')
            filterAry.push({title:`已投保商品幣別:${setCurr}`,field_name:'prod_codes_curr',option:setCOption})
          }
          //未投保商品幣別
          else if(key === 'prod_codes_n_curr' && form[key].length !== 0){
            let setCurr = ''
            let setCOption = ''            
            setCurr = '幣別:' + form[key].map(this.curr).join(':')
            setCOption = form[key].map(item => item.trim()).join(':')
            filterAry.push({title:`未投保商品幣別:${setCurr}`,field_name:'prod_codes_n_curr',option:setCOption})
          } else if (key === 'vip_lvl' && form[key].length !== 0) {
            //VIP客戶
            let text = '';
            let val = '';
            if(formItem[key]){
              formItem[key].forEach(item => {
                form[key].forEach(vipVal => {
                  if(vipVal === item.option) {
                    text += item.name + ',';
                    val += vipVal + ':';
                  }
                })
              })
              if(text !=='' && val !==''){
                text = text.substring(0, text.length - 1);
                val = val.substring(0, val.length - 1);
                filterAry.push({title:`VIP客戶:${text}`, field_name:'vip_lvl', option:val});
              }
            }
          } else if (key === 'cust_tag' && form[key].length !== 0) {
            //客戶標籤
            let tagText = form.cust_tag.map(item => item.text).join(':');
            let tagVal = form.cust_tag.map(item => item.val.trim()).join(':');
            filterAry.push({title:`客戶標籤:${tagText}`,field_name:'cust_tag',option:tagVal});
          } else if (key === 'prod_type' && form[key].length !== 0) {
            //產品類別(已投保)
            let prodTypeText = form.prod_type.map(item => item.text).join(':');
            let prodTypeVal = form.prod_type.map(item => item.val.trim()).join(':');
            filterAry.push({title:`產品類別(已投保):${prodTypeText}`,field_name:'prod_type',option:prodTypeVal});
          } else if (key === 'prod_type_n' && form[key].length !== 0) {
            //產品類別(未投保)
            let prodType_N_Text = form.prod_type_n.map(item => item.text).join(':');
            let prodType_N_Val = form.prod_type_n.map(item => item.val.trim()).join(':');
            filterAry.push({title:`產品類別(未投保):${prodType_N_Text}`,field_name:'prod_type_n',option:prodType_N_Val});
          } else if (key === 'mkt_level' && form[key].length !== 0){
            //泰好客促約潛力
            let mktLevelVal = form.mkt_level.map(item => item.trim()).join(':')
            filterAry.push({title:`泰好客促約潛力:${mktLevelVal}`,field_name:'mkt_level',option:mktLevelVal});
          } else if (key === 'mkt_type' && form[key].length !== 0){
            //泰好客商品類別
            let mktTypeText = form.mkt_type.map(item => item.text).join(':')
            let mktTypeVal = form.mkt_type.map(item => item.val.trim()).join(':')
            filterAry.push({title:`泰好客商品類別:${mktTypeText}`,field_name:'mkt_type',option:mktTypeVal})
          }
        }
      }
      //投保始期:3種情況 (1.年 2.月 3.年+月)
      if(form.custrl4){
        if(form.inputYear !== ''){
          filterAry.push({title:`投保始期年份:${form.inputYear}年`,field_name:'inputYear',option:form.inputYear});
          filterAry.push({title:`投保始期月份:${form.custrl4}月`,field_name:'custrl4',option:form.custrl4});
        } else {
          filterAry.push({title:`投保始期月份:${form.custrl4}月`,field_name:'custrl4Only',option:form.custrl4});
        }
      } else if(form.inputYear !== ''){
        filterAry.push({title:`投保始期年份:${form.inputYear}年`,field_name:'inputYearOnly',option:form.inputYear});
      }

      if(filterAry.length == 0){
        return false
      }
      //檢查已填選條件的值的總字數不得超過400個字
      let conditionStr = '';
      // 設定 要傳送出去的 condition & 選項中文
      this.conditionData = {}
      let chTextAry = []
      filterAry.forEach(item => {
        chTextAry.push(item.title)
        this.conditionData[item.field_name] = item.option
        conditionStr += item.option;
      })

      if(conditionStr.length > 400) {
        return this.setToastMsg('已勾選的條件超過限制總數，請先減少條件後再查詢');
      }
      this.option_ch = chTextAry.join(';')
    },
    previewClient() {  //  to 客戶數預覽
      if(this.count == 0) {
        return this.setToastMsg('最少要選擇1項條件做發佈')
      }
      
      if(this.count > 15) {
        return this.setToastMsg('條件組合不得設定超過15項條件')
      }

      this.setCondition() // 設定 condition
      this.$emit('set-selected-item', this.condition_title, this.conditionData, this.option_ch)
    },
    formSubmit() {  //  to 發布頁面
      if(this.count == 0) {
        return this.setToastMsg('最少要選擇1項條件做發佈')
      }
      
      if(this.count > 15) {
        return this.setToastMsg('條件組合不得設定超過15項條件')
      }
      this.setCondition() // 設定 condition

      if(!this.ageCheck) {
        return this.setToastMsg('自定義年齡只能填入數字');
      }

      if(!this.yearCheck) {
        return this.setToastMsg('投保始期年度只能填入數字');
      }      

      this.$emit('go-release-table', this.condition_title, this.conditionData, this.option_ch)
    },
    checkCustomizedAge(type, val) { //檢查自定義年齡是否為數字
      if (isNaN(val)) {
        if(type === 'age') {
          this.ageCheck = false;
        } else {
          this.yearCheck = false;
        }
        return true;
      }
    },
    //開啟標籤名稱說明視窗
    openTagInfoModal () {
      this.panelOpen('tagInfoModalOpen');
    },
    //更新已選擇客戶標籤
    updateCustTag (selectedList) {
      this.formSelectItem['cust_tag'] = selectedList;
      this.panelClose('custTagModalOpen');
    },
    //打開客戶標籤選擇 modal
    openCustTagModal(selected) {
      this.custTagSelected = selected;
      this.panelOpen('custTagModalOpen');
    },
    //更新已選擇商品類別
    updateProdType (selectedList) {
      if (this.prodType == '1') {
        this.formSelectItem['prod_type'] = selectedList;
      } else {
        this.formSelectItem['prod_type_n'] = selectedList;
      }
      this.panelClose('prodTypeModalOpen');
    },
    //打開商品類別選擇 modal
    openProdTypeModal(selected, type) {
      this.prodTypeSelected = selected;
      this.prodType = type;
      this.panelOpen('prodTypeModalOpen');
    },
    //更新已選擇商品類別(泰好客)
    updateMktType (selectedList) {
      this.formSelectItem['mkt_type'] = selectedList;
      this.panelClose('addMktTypeModalOpen');
    },
    //打開挑選商品類別(泰好客) modal
    openAddMktTypeModal(selected) {
      this.mktTypeSelected = selected;
      this.panelOpen('addMktTypeModalOpen');
    },
    //開啟泰好客說明視窗
    openCathayCustInfoModal () {
      this.panelOpen('cathayCustInfoModalOpen');
    }
  },
  mounted () {
    //  初始化
    this.initUnitFilter()
  }
}
</script>
<style lang="scss" scoped>
  .hint-text {
    font-size: 22px;
    font-weight: 600;
    color: red;
    padding-top: 10px;
  }
</style>